import MedperLogo from "../../assets/MEDPER INFINITY.svg";

/**
 * Shared frame for the signed-out screens. Brand panel on the left from `nav`
 * up, form on the right; the form alone on a phone.
 */
const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="flex min-h-screen bg-canvas">
    <div className="relative hidden w-[42%] max-w-xl flex-col justify-between bg-ink p-12 nav:flex">
      <img src={MedperLogo} alt="MedpeR" className="h-8 w-auto self-start" />

      <div>
        <p className="text-3xl font-bold leading-tight text-white">
          Each Pill, On Time,
          <br />
          Every Time.
        </p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-[#a9b8cf]">
          Track adherence, manage schedules and keep the whole family in the loop — from one place.
        </p>
      </div>

      <p className="text-sm font-semibold text-white">© {new Date().getFullYear()} MedpeR®</p>
    </div>

    <div className="flex flex-1 items-center justify-center px-5 py-10 nav:px-12">
      <div className="w-full max-w-sm">
        <img src={MedperLogo} alt="MedpeR" className="mb-8 h-7 w-auto nav:hidden" />

        <h1 className="text-2xl font-bold text-primary-900">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}

        <div className="mt-7">{children}</div>

        {footer && <div className="mt-8 border-t border-gray-200 pt-6 text-center">{footer}</div>}
      </div>
    </div>
  </div>
);

export default AuthLayout;
